import React, { useState, useEffect } from 'react';
import api from '../api/api';
import '../styles/components/AnnouncementBar.css';

/**
 * AnnouncementBar - マイページ上部に表示するお知らせバー
 *
 * お知らせタイプ:
 * - info: 通常のお知らせ（青）
 * - campaign: キャンペーン情報（紫）
 * - maintenance: メンテナンス情報（オレンジ）
 * - warning: 重要な警告（赤）
 */
const AnnouncementBar = () => {
  const [announcement, setAnnouncement] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAnnouncement = async () => {
      try {
        const response = await api.get('/api/announcements/current');
        if (response.data.success && response.data.announcement) {
          setAnnouncement(response.data.announcement);

          // 同じお知らせを閉じた履歴を確認
          const dismissedId = localStorage.getItem('dismissedAnnouncementId');
          if (dismissedId === response.data.announcement.id) {
            setDismissed(true);
          }
        }
      } catch (error) {
        // お知らせ取得失敗は静かに処理
        console.debug('お知らせ取得失敗:', error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAnnouncement();
  }, []);

  const handleDismiss = () => {
    if (announcement) {
      localStorage.setItem('dismissedAnnouncementId', announcement.id);
    }
    setDismissed(true);
  };

  // 表示しない条件
  if (loading || !announcement || dismissed) {
    return null;
  }

  const typeIcons = {
    info: 'ℹ️',
    campaign: '🎉',
    maintenance: '🔧',
    warning: '⚠️'
  };

  return (
    <div className={`announcement-bar announcement-bar--${announcement.type}`}>
      <div className="announcement-bar__content">
        <span className="announcement-bar__icon">
          {typeIcons[announcement.type] || typeIcons.info}
        </span>
        <span className="announcement-bar__text">
          {announcement.content}
        </span>
        {announcement.link && (
          <a
            href={announcement.link}
            className="announcement-bar__link"
            target={announcement.link.startsWith('http') ? '_blank' : '_self'}
            rel={announcement.link.startsWith('http') ? 'noopener noreferrer' : undefined}
          >
            {announcement.linkText || '詳細を見る'}
          </a>
        )}
      </div>
      <button
        className="announcement-bar__dismiss"
        onClick={handleDismiss}
        aria-label="閉じる"
      >
        ×
      </button>
    </div>
  );
};

export default AnnouncementBar;
